import { COMO_FUNCIONA } from '../conteudo';

// Como funciona — 4 passos em cartões numerados.
export default function PassosConheca() {
  return (
    <section className="app-entra mt-10" style={{ animationDelay: '60ms' }}>
      <h2 className="text-[19px] font-extrabold text-foreground-950 md:text-[24px]">
        Como funciona
      </h2>
      <ol className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {COMO_FUNCIONA.passos.map((passo) => (
          <li
            key={passo.numero}
            className="rounded-[18px] border border-background-200 bg-background-50 p-4 shadow-pcard"
          >
            <span className="text-[26px] font-extrabold leading-none tabular-nums text-primary-500">
              {passo.numero}
            </span>
            <h3 className="mt-2 text-[15px] font-extrabold text-foreground-950">
              {passo.titulo}
            </h3>
            <p className="mt-1 text-[14px] leading-snug text-foreground-600">{passo.texto}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}